import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { usAndTerritories } from 'commons/types/dictionaries'
import { FF2, Select, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { updateStateField } from '../../../../../../../helpers'

export const Country = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control, clearErrors, setValue, getValues } = useFormContext<SarEdit>()
  const noBranchInvolved = useWatch({ control, name: `institutionActivitiesInfo.${index1 as 0}.noBranchInvolved` })

  return (
    <Controller
      name={`institutionActivitiesInfo.${index1 as 0}.institutionActivityBranchesInfo.${index2 as 0}.country`}
      control={control}
      rules={{
        validate: (value) => (noBranchInvolved ? undefined : Validators.required.field(value))
      }}
      render={({ field }) => (
        <FF2
          required={!noBranchInvolved}
          label="74. Country"
          field={field}
          input={(props) => (
            <Select
              {...props}
              data={usAndTerritories}
              data-qa="74. Country"
              options-data-qa="74. Country option"
              disabled={noBranchInvolved}
              onChange={(value) => {
                updateStateField(
                  `institutionActivitiesInfo.${index1 as 0}.institutionActivityBranchesInfo.${index2 as 0}.state`,
                  value,
                  setValue,
                  getValues,
                  clearErrors
                )
                field.onChange(value)
              }}
            />
          )}
        />
      )}
    />
  )
}
